// extracted by mini-css-extract-plugin
export default {"root":"NewListingBadge_root__iksP5"};